// "Add to calendar" for an IMPROVE Live webinar booking: Outlook (Microsoft
// 365) and Google Calendar links, and a calendar file for everything else.
// The file uses the booking's own UID, the same one as the invite we email,
// so a calendar that already has the event updates it rather than adding a
// second one.
//
// An event is { uid, sequence, title, details, start, end, url }, start and
// end being ISO 8601 times (the API's booking.session_at and ends_at).

function utcStamp(iso) {
  return new Date(iso).toISOString().replace(/[-:]/g, "").replace(/\.\d{3}/, "");
}

export function outlookCalendarLink(event) {
  return (
    "https://outlook.office.com/calendar/0/deeplink/compose?path=%2Fcalendar%2Faction%2Fcompose&rru=addevent" +
    "&subject=" + encodeURIComponent(event.title) +
    "&startdt=" + encodeURIComponent(new Date(event.start).toISOString()) +
    "&enddt=" + encodeURIComponent(new Date(event.end).toISOString()) +
    "&body=" + encodeURIComponent(event.details) +
    "&location=" + encodeURIComponent("Microsoft Teams")
  );
}

export function googleCalendarLink(event) {
  return (
    "https://calendar.google.com/calendar/render?action=TEMPLATE" +
    "&text=" + encodeURIComponent(event.title) +
    "&dates=" + utcStamp(event.start) + "/" + utcStamp(event.end) +
    "&details=" + encodeURIComponent(event.details) +
    "&location=" + encodeURIComponent("Microsoft Teams")
  );
}

function icsText(value) {
  return String(value)
    .replace(/\\/g, "\\\\")
    .replace(/;/g, "\\;")
    .replace(/,/g, "\\,")
    .replace(/\r?\n/g, "\\n");
}

function utf8Length(char) {
  return encodeURIComponent(char).replace(/%[0-9A-F]{2}/g, "x").length;
}

// RFC 5545 lines are at most 75 octets; longer ones continue after CRLF + space.
function fold(line) {
  const parts = [];
  let current = "";
  let size = 0;
  let limit = 75;
  for (const char of Array.from(line)) {
    const bytes = utf8Length(char);
    if (size + bytes > limit) {
      parts.push(current);
      current = "";
      size = 0;
      limit = 74;
    }
    current += char;
    size += bytes;
  }
  parts.push(current);
  return parts.join("\r\n ");
}

export function icsFile(event) {
  const lines = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//IMPROVE//IMPROVE Live//EN",
    "CALSCALE:GREGORIAN",
    "METHOD:PUBLISH",
    "BEGIN:VEVENT",
    "UID:" + event.uid,
    "SEQUENCE:" + (Number(event.sequence) || 0),
    "DTSTAMP:" + utcStamp(new Date().toISOString()),
    "DTSTART:" + utcStamp(event.start),
    "DTEND:" + utcStamp(event.end),
    "SUMMARY:" + icsText(event.title),
    "DESCRIPTION:" + icsText(event.details),
    "LOCATION:Microsoft Teams"
  ];
  if (event.url) lines.push("URL:" + event.url);
  lines.push("STATUS:CONFIRMED", "END:VEVENT", "END:VCALENDAR");
  return lines.map(fold).join("\r\n") + "\r\n";
}

export function downloadIcsFile(event, filename) {
  const blob = new Blob([icsFile(event)], { type: "text/calendar;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setTimeout(function() {
    URL.revokeObjectURL(url);
  }, 1000);
}
